<!--
  创建时间：2023/7/29 14:50
  创建人：toyehuang
  文件描述：BannerSwipper
-->

<template>
  <el-carousel height="450px" :interval="15000">
    <el-carousel-item v-for="(item, index) in swiperList" :key="index">
      <Link :to="item.url" target="_blank">
        <img :src="item.adImage" alt="" class="link-item">
      </Link>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import adApi from "@/api/ad";
import { AD_CODE } from "@/utils/constant";
export default {
  name: "BannerSwiper",
  components: { Link },
  props: {},
  data() {
    return {
      swiperList: []
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getAdList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    getAdList() {
      adApi.page({ pageNo: 1, pageSize: 10, type: AD_CODE.BANNER }).then((res) => {
        this.swiperList = res.data.list;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.link-item {
  width: 100%;
  height: 450px;
}
::v-deep {
  .el-carousel__arrow {
    width: 50px;
    height: 50px;
    font-size: 30px;
    background-color: rgba(0, 0, 0, 0.5);
    &:hover {
      background-color: rgba(0, 0, 0, 0.8);
    }
  }
  .el-carousel__arrow--left {
    left: 50%;
    transform: translate(-600px, -50%);
  }
  .el-carousel__arrow--right {
    right: 50%;
    transform: translate(600px, -50%);
  }
}
</style>
